<template>
  <div id="home" class="home">
    <div class="head">
      <div class="head-text">
        <span>已有</span>
        <span class="head-text-num">{{ wishTotal }}</span>
        <span>人为武汉祈福</span>
      </div>
    </div>
    <div class="barrage">
      <!-- <marquee behavior="scroll" scrollamount="6"> -->
      <template v-for="barrage in barrage_arr" >
        <van-notice-bar :scrollable="true">
          <!-- <div class="barrage-list" :style="'width:'+barrage.width+'vw;'" > -->
              <div class="barrage-item" v-for="(item, index) in barrage.data" v-bind:key="index">
                <img v-if="item.headimg" :src="item.headimg" alt="" />
                <span>{{ item.text }}</span>
              </div>
          <!-- </div> -->
        </van-notice-bar>
      </template>
      <!-- </marquee> -->
    </div>
    <div @click="goEdit" class="submit"></div>
    <div class="bottom flex-row">
      <div class="text flex-data">
        全球华人共同抗疫<br />
        <span>中国移动无忧行</span>助您与国内亲友免费通话
      </div>
      <div
        v-if="activityInfo && activityInfo.isopen == 1"
        @click="getFree"
        class="btn"
      ></div>
      <div v-else class="btn" style="opacity:0.4"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { NoticeBar } from "vant";
Vue.use(NoticeBar);

import config from "@/config";
export default {
  name: "home",
  urlData: {},
  data() {
    return {
      barrage_arr:[],
      barrage_data: [
        "我在莫斯科，好久不见，我只愿你平安",
        "我在潮州，干炒牛河会遇上热干面",
        "我在兰州，隔离病毒但不隔离爱",
        "我在伦敦， 爱与希望有无限的力量",
        "我在湖南，戴口罩勤洗手，决不出门到处走！",
        "我在新西兰，相信我们一定会胜利",
        "我在黄石，加油加油加油加油！",
        "我在洛阳，万众一心，共渡难关",
        "我在浙江，我们都在努力！加油！",
        "我在辽宁，武汉人民加油！我们一直在你们身后！",
        "我在大连，2020我们祈福武汉，千难万险一起走！",
        "我在鞍山，愿大家都平安。",
        "我在长春，愿所有奋斗在抗战一线的人们，都能安全归来，",
        "我在成都，医护工作者，你们都是伟大的勇士，向你们致敬！",
        "我在宜宾，众志成城共同抗疫，中国雄起！",
        "我在绵阳，希望这场疫情早日结束，大家都能平平安安健健康康！",
        "我在南充，2020年大家都要平安健康，武汉加油！",
        "我在常德，热干面加油！",
        "我在伦敦，I will always be with you, my dear Wuhan",
        "我在怀化，每个中国人，都在为抗击病毒而努力，一定会很快好起来！",
        "我在岳阳，天佑武汉，天佑中华！",
        "我在昆明，武汉人民加油好起来，昆明等你们来玩~",
        "我在丽江，大家都要努力抗击病情呀！无限风光还等着咱们一起看呢~",
        "我在悉尼，Stay with you! Wuhan",
        "我在大理，保护好自己，也是保护他人，加油！",
        "我在拉萨，向天祈福，大家一定要好起来！",
        "我在广东，等樱花开，我们武汉见",
        "我在加州，天佑中华，为武汉祈福",
        "我在河南，聚焦祈福武汉，稳住！",
        "我在曼谷，加油白衣天使！ 加油武汉！加油中国！",
        "我在上海，向逆行的战士敬礼！",
        "我在长沙，愿离别终能相逢",
        "我在新加坡，Pray for Wuhan, God bless China",
        "我在厦门，为挖掘机天团打call！",
        "我在青岛，武汉加油！我们一起打赢这场仗！",
        "我在桂林，大家照顾好自己，愿疫情早日平复！",
        "我在腾冲，武汉挺住！",
        "我在漠河，希望更多物资抵达一线！疫情尽快好起来！",
        "我在武汉，希望我们的城市尽快战胜病魔！",
        "我在肯尼亚，全球华人都心系祖国，我们万众一心，定能胜利。",
        "我在泰国，我爱祖国。武汉加油！",
        "我在仙桃，平安健康就是最大的愿望。",
        "我在赣州，一起为武汉加油，向医护工作者们致敬！",
        "我在辽宁，武汉人民加油！我们一直在你们身后！",
        "我在大连，2020我们祈福武汉，千难万险一起走！",
        "我在鞍山，愿大家都平安。",
        "我在长春，愿所有奋斗在抗战一线的人们，都能安全归来，",
        "我在成都，医护工作者，你们都是伟大的勇士，向你们致敬！",
        "我在宜宾，众志成城共同抗疫，中国雄起！",
        "我在南充，2020年大家都要平安健康，武汉加油！",
        "我在常德，热干面加油！",
        "我在昆明，武汉人民加油好起来，昆明等你们来玩~",
        "我在丽江，大家都要努力抗击病情呀！无限风光还等着咱们一起看呢~",
        "我在大理，保护好自己，也是保护他人，加油！",
        "我在拉萨，向天祈福，大家一定要好起来！",
        "我在仙桃，奋斗在抗疫一线的人们，谢谢你们，像你们致敬！",
        "我在湛江，奋斗在一线的医护人员，都要平平安安啊！",
        "我在清远，武汉人民加油！等你们好了，一起来清远泡温泉鸭~",
        "我在肇庆，武汉牵动着全国人民的心，全国人们携手，定能攻克难关！",
        "我在江西，武汉加油！"],
      text_count: 0
    };
  },
  methods: {
    // initbarrage: function() {
    //   var t = this;
    //   var text_count = 0;
    //   for (var i = 0; i < t.barrage.length; i++) {
    //     text_count += t.barrage[i].text.length;
    //   }

    //   t.text_count = text_count;
    //   console.log("text_count", text_count);
    // },
    getFree() {
      this._deepmain(this.pageId, "进入领取语音包活动", 2,function(){
        window.location.href =
          "https://cp.jegotrip.com.cn/partners/skuact/index.html?actName=act1&actId=278";
      });

    },
    goEdit() {
      this.$router.push({
        path: "/newvow",
        query: {}
      });
      this._deepmain(this.pageId, "马上祈福", 2)
    },
    initbarrage(){
      var t = this;
      var row = 3;
      var barrage_item_count = t.barrage_data.length/row;
      var j = 0;
      for(var i=0;i<row;i++)
      {
        var barrage = [];
        while(true){
          j++;
          barrage.push({
            headimg: require("../../static/images/headimg/"+j+".jpg"),
            text: t.barrage_data[0]
          });
          t.barrage_data.splice(0,1);
          if(j%barrage_item_count==0 || t.barrage_data.length<=0) break;
        }
        t.barrage_arr.push({data:barrage})
      }
      console.log("t.barrage_arr",t.barrage_arr)
    },
  },
  components: {},
  created() {
    console.log('##window.location###',window.location)
    this.initbarrage();
    this._deepmain(this.pageId, "首页访问", 0);
  }
};
</script>
<style lang="scss">
@import "../../static/scss/home.scss";
</style>
